import {
  trackCdp,
  trackCheckoutClick,
  trackEvent,
  trackGA,
} from 'utilities/tracking';

window.Sq = window.Sq || {};
Sq.Shop = Sq.Shop || {};

Sq.Shop.Utils = {
  PRODUCT_DATA_ATTR: 'data-product-data',
  ADD_ON_DATA_ATTR: 'data-add-on-data',
  CART_DATA_ATTR: 'data-cart-data',
  DIAGNOSTIC_DATA_ATTR: 'data-diagnostic-data',

  QUANTITY_SELECTOR: '[name="line_items[][quantity]"]',
  REMOVE_SELECTOR: '[name="remove"]',
  CHECKBOX_SELECTOR: '.button-toggle input',

  FLASH_BANNER_SELECTOR: '#flash-banner',

  BASE_SHOP_URL_REGEX:
    /^ht{2}ps?:\/{2}(squareup|squareupstaging|localhost:\d+)(\.com)?\/shop\/hardware(?:\/[a-z]{2}){2}/,

  cartData() {
    const json = $(`[${this.CART_DATA_ATTR}]`).attr(this.CART_DATA_ATTR);

    if (!json) {
      return {};
    }

    const data = JSON.parse(json);
    data.id = data.number;
    return data;
  },

  cartNumber() {
    if (!this.cartData() || !this.cartData().number) {
      throw new Error('Sq.Utils: No cart number found!');
    }
    return this.cartData().number;
  },

  productData(el, attr = this.PRODUCT_DATA_ATTR) {
    const $product = $(el).closest(`[${attr}]`);

    if ($product.length === 0) {
      return false;
    }

    const $qty = $product.find(this.QUANTITY_SELECTOR);
    const $checkbox = $product.find(this.CHECKBOX_SELECTOR);

    // GA enhanced e-commerce product data
    const data = JSON.parse($product.attr(attr));
    data.id = data.sku;

    if ($qty.length > 0) {
      data.quantity = Number.parseInt($qty.val(), 10);
    }

    if ($checkbox.length > 0) {
      data.selected = $checkbox.prop('checked');
    }

    // exclude quickview fields from tracking data
    delete data.description;
    delete data.display_price;
    delete data.max;

    return data;
  },

  diagnosticData() {
    const json = $(`[${this.DIAGNOSTIC_DATA_ATTR}]`).attr(
      this.DIAGNOSTIC_DATA_ATTR
    );
    return JSON.parse(json);
  },

  // Queue up a list of products for enhanced ecommerce action
  trackProductList(el, { listName, cartNumber, impression }) {
    $(el)
      .find(`[${this.PRODUCT_DATA_ATTR}]`)
      .each((i, el) => {
        const product = this.productData(el);
        product.position = i;

        if (listName) {
          product.list = listName;
        }

        if (cartNumber) {
          product.cartNumber = cartNumber;
        }

        const ec = impression ? 'ec:addImpression' : 'ec:addProduct';
        trackGA(ec, product);
      });
  },

  trackCheckoutStep(el, { index, name, complete }) {
    const cartData = this.cartData();
    if (!cartData) {
      return;
    }

    this.trackProductList(el, {
      listName: 'Cart',
      cartNumber: this.cartNumber(),
    });

    trackGA('ec:setAction', 'checkout', { step: index });
    if (complete) {
      trackGA('ec:setAction', 'purchase', cartData);
    }

    trackEvent('Checkout', `Step ${index}: ${name}`, cartData);

    trackCdp({
      name: 'View Checkout Step',
      params: {
        feature: 'shop',
        order_number: this.cartData().number,
        step: name,
      },
    });
  },

  trackCheckoutClick(el, { event_desc, additional_details = {} }) {
    const cartData = this.cartData();
    if (!cartData) {
      return;
    }

    trackCdp({
      name: 'Complete Checkout Step',
      params: {
        feature: 'shop',
        order_number: cartData.number,
        step: event_desc,
      },
    });
    trackCheckoutClick(event_desc, cartData, additional_details);
  },

  flashBanner() {
    return $(this.FLASH_BANNER_SELECTOR).data('sq.flash');
  },

  downloadFile(data_blob, filename) {
    const element = document.createElement('a');

    element.setAttribute('href', URL.createObjectURL(data_blob));
    element.setAttribute('download', filename);
    element.style.display = 'none';

    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  },
};

export default Sq.Shop.Utils;
